import logger from 'src/logger';
import LineItemII from './LineItemII';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';

import {
  getFormatImage,
  mergeAddons,
  getTitle,
  getType,
  getCustomisations,
  getCustomisationString,
  getExpandedCustomisation,
  buildEditUrl,
  getPrismicProductAndAddons,
} from '../CartItems/LineItem/helpers';
import {
  trackRemoved,
  trackEditAddons,
  trackEditItem,
  trackAddAddons,
} from '../../../analytics/category/cart';

import orderBy from 'lodash/orderBy';
import withCountry from '../../hocs/withCountry';
import withProductKey from '../../hocs/withProductKey';
import withPrismicProduct from '../../hocs/withPrismicProduct';

const enhance = compose(
  withCountry,
  withState('isLoading', 'setIsLoading', true),
  withState('giftwrapCta', 'updateGiftwrapCta', null),
  withState('extrasCta', 'updateExtraCta', null),
  withProps(props => ({
    productId: props.item.format.product.id,
    productLocale: props.item.customisations.locale,
    lineItemPrefix: props.model.prismicGlobalContentModel.general.lineItemPrefix,
  })),
  withPrismicProduct(['productInformation', 'cart', 'form']),
  withHandlers({
    onRemove: props => () => {
      try {
        trackRemoved(props.item.format.product.id);
      } catch (error) {
        logger.error(error);
      }
      return props.handleRemove(props.item.id);
    },
    onEditItem: props => () => trackEditItem(props.item.format.product.id),
    onEditAddons: props => () => trackEditAddons(props.item.format.product.id),
    onAddAddons: props => () => trackAddAddons(props.item.format.product.id),
  }),
  withProductKey,
  lifecycle({
    componentDidMount() {
      getPrismicProductAndAddons(this.props);
    },
  }),
  withProps(props => {
    const addons = orderBy(mergeAddons(props), ['type'], ['desc']);
    let expandedCustomisation = getExpandedCustomisation(props, addons);
    expandedCustomisation = props.isCustomisationsExpanded && expandedCustomisation.length > 0
      ? expandedCustomisation
      : [];
    return {
      onClickLink: {
        editItem: props.onEditItem,
        editAddons: props.onEditAddons,
        addAddons: props.onAddAddons,
      },
      image: getFormatImage(props).image,
      title: getTitle(props),
      customisationString: getCustomisationString(props),
      expandedCustomisation,
      itemCustomisation: props.item.customisations,
      type: getType(props),
      addons,
      price: props.item.price,
      savings: props.item.savings,
      editUrl: buildEditUrl(props),
      hasCustomisations: !!getCustomisations(props)
    };
  }),
);

export default enhance(LineItemII);



// WEBPACK FOOTER //
// ./src/client/js/view/components/LineItemII/index.js